export default __webpack_public_path__ + "static/media/icVisibleOff.d92bf37b.svg";